// extracted by mini-css-extract-plugin
export default {"PageWrapper":"PageWrapper_PageWrapper__e3T2S"};